import AuthAPI from './authInstance'

const getAll = async () => {
  
  const response = await AuthAPI.get(`/admin/examname`)
  return response.data
}

const getOne = async (data) => {
  const response = await AuthAPI.get(`/admin/examname/show/${data}`)
  return response.data
}

const createExamname = async (data) => {
  const response = await AuthAPI.post(`/admin/examname/create`, data)
  return response.data
}

const editExamname = async (data) => {
  const response = await AuthAPI.post(`/admin/examname/update`, data)
  return response.data
}

const deleteOne = async (data) => {
  const response = await AuthAPI.delete(`/admin/examname/delete/${data}`)
  return response.data
}

export const examNameService = {
  getAll,
  getOne,
  createExamname,
  editExamname,
  deleteOne,
}
